// Module
var code = `<!-- 1. Start here -->
<div class="jumbotron-surface style-guide-section">
  <div class="jumbotron-panel-head style-guide-section-head">
    <span class="jumbotron-heading">Start here</span>
    <span class="jumbotron-note">Read this first. The rest of the page is the catalogue.</span>
  </div>
  <div class="style-guide-body">

    <p class="jumbotron-field-label">The one rule</p>
    <p class="style-guide-rule">{{ \$ctrl.rule }}</p>

    <p class="jumbotron-field-label">Do not</p>
    <ul class="style-guide-list">
      <li ng-repeat="entry in \$ctrl.forbidden track by entry">{{ entry }}</li>
    </ul>

    <p class="jumbotron-field-label">When it does not fit</p>
    <ul class="style-guide-list">
      <li ng-repeat="entry in \$ctrl.whenItDoesNotFit track by entry">{{ entry }}</li>
    </ul>

    <p class="jumbotron-field-label">The recipe</p>
    <div class="style-guide-recipe">
      <pre class="style-guide-code"><code>{{ \$ctrl.recipe }}</code></pre>
      <div class="jumbotron-surface my-panel">
        <div class="jumbotron-panel-head">
          <span class="jumbotron-heading">Panel</span>
          <button type="button" class="btn btn-sm btn-outline-primary">Action</button>
        </div>
        <div class="my-panel-body">
          <span class="jumbotron-note">The rules of this panel are under .my-panel in the LESS file of the component.</span>
        </div>
      </div>
    </div>

    <p class="jumbotron-field-label">Your LESS file</p>
    <ul class="style-guide-list">
      <li ng-repeat="entry in \$ctrl.lessRules track by entry">{{ entry }}</li>
    </ul>

    <p class="jumbotron-field-label">Not shared yet</p>
    <ul class="style-guide-list">
      <li ng-repeat="entry in \$ctrl.notShared track by entry">{{ entry }}</li>
    </ul>

  </div>
</div>

<!-- 2. Tokens -->
<div class="jumbotron-surface style-guide-section">
  <div class="jumbotron-panel-head style-guide-section-head">
    <span class="jumbotron-heading">Tokens</span>
    <span class="jumbotron-note">A page reads a token with var(). The values are in client/style/tokens.less. Two values per colour: the light one and the dark one under data-bs-theme=dark.</span>
  </div>
  <div class="style-guide-body">

    <p class="jumbotron-field-label">Colours</p>
    <div class="style-guide-grid">
      <div class="style-guide-swatch" ng-repeat="token in \$ctrl.colourTokens track by token.name">
        <span class="style-guide-swatch-chip" ng-style="{ background: token.swatch || 'var(' + token.name + ')' }"></span>
        <!-- The second chip stands in a dark scope, so a token that reads a Bootstrap property shows its dark value too. -->
        <span class="style-guide-dark-chip" data-bs-theme="dark" ng-if="token.dark" title="Dark theme">
          <span class="style-guide-dark-chip-fill" ng-style="{ background: token.swatch || 'var(' + token.name + ')' }"></span>
        </span>
        <span class="style-guide-sample">
          <code class="style-guide-caption">{{ token.name }}</code>
          <span class="jumbotron-note">{{ token.value }}</span>
          <span class="jumbotron-note" ng-if="token.dark">Dark: {{ token.dark }}</span>
        </span>
      </div>
    </div>

    <p class="jumbotron-field-label">Playlist colours</p>
    <p class="jumbotron-note">In the calendar, a colour says which playlist it is and nothing else. The values are in client/common/playlist-colour.js, and both themes use them.</p>
    <div class="style-guide-grid">
      <div class="style-guide-swatch" ng-repeat="colour in \$ctrl.playlistColours track by colour">
        <span class="style-guide-swatch-chip" ng-style="{ background: colour }"></span>
        <span class="style-guide-sample">
          <code class="style-guide-caption">{{ colour }}</code>
        </span>
      </div>
    </div>

    <p class="jumbotron-field-label">Font</p>
    <div class="style-guide-grid">
      <div class="style-guide-sample" ng-repeat="token in \$ctrl.fontTokens track by token.name">
        <span class="style-guide-text" ng-style="{ 'font-family': 'var(' + token.name + ')' }">Orange Stage</span>
        <code class="style-guide-caption">{{ token.name }} &middot; {{ token.value }}</code>
      </div>
    </div>

    <p class="jumbotron-field-label">Type sizes</p>
    <div class="style-guide-grid">
      <div class="style-guide-sample" ng-repeat="token in \$ctrl.typeTokens track by token.name">
        <span class="style-guide-text" ng-style="{ 'font-size': 'var(' + token.name + ')' }">Orange Stage</span>
        <code class="style-guide-caption">{{ token.name }} &middot; {{ token.value }}</code>
      </div>
    </div>

    <p class="jumbotron-field-label">Shadows</p>
    <div class="style-guide-grid">
      <div class="style-guide-sample" ng-repeat="token in \$ctrl.shadowTokens track by token.name">
        <span class="style-guide-shadow-demo" ng-style="{ 'box-shadow': 'var(' + token.name + ')' }"></span>
        <code class="style-guide-caption">{{ token.name }} &middot; {{ token.value }}</code>
      </div>
    </div>

    <p class="jumbotron-field-label">Measures</p>
    <div class="style-guide-grid">
      <div class="style-guide-sample" ng-repeat="token in \$ctrl.measureTokens track by token.name">
        <span class="style-guide-measure-demo" ng-class="token.demo">
          <span></span>
          <span></span>
        </span>
        <code class="style-guide-caption">{{ token.name }} &middot; {{ token.value }}</code>
      </div>
    </div>

    <p class="jumbotron-field-label">Layers</p>
    <div class="style-guide-grid">
      <div class="style-guide-sample" ng-repeat="token in \$ctrl.layerTokens track by token.name">
        <span class="jumbotron-note">A page above this one adds to the token with calc().</span>
        <code class="style-guide-caption">{{ token.name }} &middot; {{ token.value }}</code>
      </div>
    </div>

  </div>
</div>

<!-- 3. Type -->
<div class="jumbotron-surface style-guide-section">
  <div class="jumbotron-panel-head style-guide-section-head">
    <span class="jumbotron-heading">Type</span>
    <span class="jumbotron-note">The header of a page uses the title and the subtitle. The name of a panel is a heading. A label names a group or a field. The kind size is also the size of a mark: a tick, a badge or a glyph.</span>
  </div>
  <div class="style-guide-body">
    <div class="style-guide-grid">
      <div class="style-guide-sample">
        <span class="jumbotron-title">Report</span>
        <code class="style-guide-caption">.jumbotron-title</code>
      </div>
      <div class="style-guide-sample">
        <span class="jumbotron-subtitle">What the screens played</span>
        <code class="style-guide-caption">.jumbotron-subtitle</code>
      </div>
      <div class="style-guide-sample">
        <span class="jumbotron-heading">Findings</span>
        <code class="style-guide-caption">.jumbotron-heading</code>
      </div>
      <div class="style-guide-sample">
        <span class="jumbotron-kind-label">Screen time</span>
        <code class="style-guide-caption">.jumbotron-kind-label</code>
      </div>
      <div class="style-guide-sample">
        <span class="jumbotron-field-label">From</span>
        <code class="style-guide-caption">.jumbotron-field-label</code>
      </div>
      <div class="style-guide-sample">
        <span class="jumbotron-note">Sorted by screen time.</span>
        <code class="style-guide-caption">.jumbotron-note</code>
      </div>
      <div class="style-guide-sample">
        <span class="style-guide-text">A row of a table or of a list.</span>
        <code class="style-guide-caption">var(--jumbotron-small-size)</code>
      </div>
    </div>
  </div>
</div>
`;
// Exports
export default code;